module.exports = __webpack_public_path__ + "static/1-fcda453a5558f55dee2c50b661a2a1e2.png";